import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.CATEGORIES_LIST, { params: payload }),
    getRefs: payload => axios.get(HTTP.CATEGORIES_REFS, { params: { id: payload } }),
    addRef: payload => axios.post(HTTP.CATEGORIES_REFS, payload),
    deleteRef: payload => axios.delete(HTTP.CATEGORIES_REFS, { params: { id: payload } }),
    addCategory: payload => axios.post(HTTP.CATEGORY, payload),
    deleteCategory: payload => axios.delete(HTTP.CATEGORY, { params: { id: payload } }),
    getCategory: payload => axios.get(HTTP.CATEGORY, { params: { id: payload } }),
    updateCategory: payload => axios.put(HTTP.CATEGORY, { ...payload })
}
